import { useTranslation } from 'react-i18next';

import { Section } from 'components/Display/Section/Section';

import { ReadOnlyIndicator } from './ReadOnlyIndicator';

type CustomInstructionsSectionProps = {
  customInstructions: string | null;
};

export const CustomInstructionsSection = ({ customInstructions }: CustomInstructionsSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section.Horizontal
      title={t('settings:documentUnderstandingAgent.global.customInstructions.title')}
      description={t('settings:documentUnderstandingAgent.global.customInstructions.description')}
      action={<ReadOnlyIndicator />}
    >
      {customInstructions ? (
        <p className="text-sm whitespace-pre-wrap text-gray-700">{customInstructions}</p>
      ) : (
        <span className="text-sm text-gray-400">
          {t('settings:documentUnderstandingAgent.global.customInstructions.empty')}
        </span>
      )}
    </Section.Horizontal>
  );
};
